module.exports = require("./moment.js");


//////////////////
// WEBPACK FOOTER
// moment (bower component)
// module id = 1254
// module chunks = 1